import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DocumentItem {
  id: number;
  documentName: string;
  category?: string;
  typeOfDocument?: string;
  documentType?: string;
  downloadUrl: string;
  fileSize: number;
  mimeType: string;
  uploadedAt: string;
}

export interface McaDocuments {
  status: string;
  message: string;
  entityId?: string;
  entityName?: string;
  entityType?: string;
  totalDocuments?: number;
  completedDocuments?: number;
  completedAt?: string;
  orderCreatedAt?: string;
  documents: DocumentItem[];
}

export interface LegalCheckDocuments {
  status: string;
  message: string;
  numberOfCases?: number | null;
  riskType?: string | null;
  riskSummary?: string | null;
  companyName?: string;
  completedAt?: string | null;
  orderCreatedAt?: string;
  documents: DocumentItem[];
}

export interface DownloadDocumentsDialogData {
  confirmedName: string;
  pan: string;
  mcaDocuments: McaDocuments | null;
  legalCheckDocuments: LegalCheckDocuments | null;
}

@Component({
  selector: 'app-download-documents-dialog',
  templateUrl: './download-documents-dialog.component.html',
  styleUrls: ['./download-documents-dialog.component.scss']
})
export class DownloadDocumentsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DownloadDocumentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DownloadDocumentsDialogData
  ) {}

  get hasMcaDocuments(): boolean {
    return !!(this.data.mcaDocuments?.documents?.length);
  }

  get hasLegalDocuments(): boolean {
    return !!(this.data.legalCheckDocuments?.documents?.length);
  }

  get mcaStatus(): string {
    return this.data.mcaDocuments?.status || '';
  }

  get legalStatus(): string {
    return this.data.legalCheckDocuments?.status || '';
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  getFileIcon(mimeType: string): string {
    if (mimeType === 'application/zip') return 'folder_zip';
    if (mimeType === 'application/pdf') return 'picture_as_pdf';
    return 'description';
  }

  downloadDocument(doc: DocumentItem): void {
    window.open(doc.downloadUrl, '_blank');
  }

  onClose(): void {
    this.dialogRef.close();
  }
}

